import { motion } from 'framer-motion';

export type LineAnimationProps = {
  to?: number;
};

const width = 200;
const duration = 1;

export function LineAnimation({ to = 100 }: LineAnimationProps) {
  return (
    <motion.div
      style={{
        zIndex: 1,
        width: '200px',
        height: '100%',
        backgroundColor: 'white',
        position: 'absolute',
        left: -width,
        background: 'linear-gradient(100deg, rgba(255, 255, 255, 0.00) 37.6%, rgba(255, 255, 255, 0.40) 89.98%, rgba(255, 255, 255, 0.00) 90.19%)',
      }}
      animate={{ x: to + width }}
      transition={{
        ease: 'linear',
        duration,
        repeat: Infinity,
        repeatDelay: 3,
      }}
    />
  );
}
